import React from 'react';
import { CheckCircle2, HelpCircle, Shield } from 'lucide-react';
import { SEO } from '../components/SEO';
interface PageProps {
  openGetStarted?: () => void;
}
export function Pricing({
  openGetStarted
}: PageProps) {
  const plans = [{
    name: 'Starter',
    target: 'Entry-Level Professionals',
    price: '149',
    desc: 'Perfect for recent graduates and professionals with 0-3 years of experience.',
    features: ['Professional Resume Writing', 'ATS Keyword Optimization', '2 Rounds of Revisions', '5-Day Turnaround Time', 'Word & PDF Formats', 'Direct Messaging with Writer'],
    highlight: false
  }, {
    name: 'Professional',
    target: 'Mid-Level Professionals',
    price: '249',
    desc: 'Our most popular package for professionals with 3-10 years of experience.',
    features: ['Everything in Starter, plus:', 'Custom Cover Letter', 'LinkedIn Profile Optimization', 'Unlimited Revisions (14 days)', '3-Day Turnaround Time', 'Interview Prep Guide (PDF)'],
    highlight: true
  }, {
    name: 'Executive',
    target: 'Directors & C-Suite',
    price: '399',
    desc: 'Comprehensive career branding for senior leaders and executives.',
    features: ['Everything in Professional, plus:', 'Executive-Level Resume Writer', 'Executive Bio Document', '48-Hour Turnaround Time', '1-on-1 Strategy Call (45 min)', 'Post-Interview Follow-up Templates'],
    highlight: false
  }];
  return <div className="w-full pt-20 pb-24" data-id="element-464">
      <SEO title="Pricing | Resume Writing Service Packages | Hirelio" description="Transparent, flat-rate resume writing packages. Compare Starter, Professional, and Executive plans with ATS optimization, LinkedIn, and a 60-day interview guarantee." data-id="element-465" />
      {/* Pricing Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 relative z-10" data-id="element-466">
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-467">
          {plans.map((plan, idx) => <div key={idx} className={`relative rounded-3xl p-8 flex flex-col ${plan.highlight ? 'bg-navy-900 text-white shadow-2xl scale-105 md:-mt-4 md:mb-4 z-10' : 'bg-white dark:bg-navy-800 text-navy-900 dark:text-white border border-slate-200 dark:border-navy-700 shadow-sm mt-8'}`} data-id="element-468">
              {plan.highlight && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-469">
                  Most Popular
                </div>}
              <div className="mb-6" data-id="element-470">
                <h3 className="text-2xl font-heading font-bold mb-2" data-id="element-471">
                  {plan.name}
                </h3>
                <p className={`text-sm ${plan.highlight ? 'text-slate-400' : 'text-slate-500 dark:text-slate-400'}`} data-id="element-472">
                  {plan.target}
                </p>
              </div>
              <div className="mb-4" data-id="element-473">
                <span className="text-5xl font-heading font-bold" data-id="element-474">
                  ${plan.price}
                </span>
                <span className={plan.highlight ? 'text-slate-400' : 'text-slate-500'} data-id="element-475">
                  /one-time
                </span>
              </div>
              <p className={`mb-8 text-sm leading-relaxed ${plan.highlight ? 'text-slate-300' : 'text-slate-600 dark:text-slate-400'}`} data-id="element-476">
                {plan.desc}
              </p>
              <ul className="space-y-4 mb-8 flex-grow" data-id="element-477">
                {plan.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3" data-id="element-478">
                    <CheckCircle2 size={20} className={plan.highlight ? 'text-brand-400 shrink-0' : 'text-brand shrink-0'} data-id="element-479" />
                    <span className={`text-sm ${plan.highlight ? 'text-slate-200' : 'text-slate-700 dark:text-slate-300'}`} data-id="element-480">
                      {feature}
                    </span>
                  </li>)}
              </ul>
              <button onClick={openGetStarted} className={`w-full py-4 rounded-xl font-medium transition-all mt-auto ${plan.highlight ? 'bg-brand hover:bg-brand-600 text-white shadow-lg shadow-brand/25' : 'bg-slate-100 dark:bg-navy-700 hover:bg-slate-200 dark:hover:bg-navy-600 text-navy-900 dark:text-white'}`} data-id="element-481">
                Get Started
              </button>
            </div>)}
        </div>
      </div>

      {/* Guarantee */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-24" data-id="element-482">
        <div className="bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-900/50 rounded-2xl p-8 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left" data-id="element-483">
          <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-900/50 text-emerald-600 dark:text-emerald-400 rounded-full flex items-center justify-center shrink-0" data-id="element-484">
            <Shield size={32} data-id="element-485" />
          </div>
          <div data-id="element-486">
            <h3 className="text-xl font-heading font-bold text-navy-900 dark:text-white mb-2" data-id="element-487">
              60-Day Interview Guarantee
            </h3>
            <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed" data-id="element-488">
              If you don't receive 2x more interviews within 60 days of
              receiving your final resume, we will rewrite it for free. Your
              success is our success.
            </p>
          </div>
        </div>
      </div>
    </div>;
}